export const AUTH_LOAD = 'AUTH_LOAD'
export const AUTH_LOAD_SUCCESS = 'AUTH_LOAD_SUCCESS'
export const AUTH_LOAD_FAIL = 'AUTH_LOAD_FAIL'
export const LOGIN_LOAD = 'LOGIN_LOAD'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'

export const ME_LOAD = 'ME_LOAD'
export const ME_SUCCESS = 'ME_SUCCESS'
export const ME_FAIL = 'ME_FAIL'

// export const INITIAL_LOAD = 'INITIAL_LOAD'

export const SITES_LOAD = 'SITES_LOAD'
export const SITES_LOAD_SUCCESS = 'SITES_LOAD_SUCCESS'
export const SITES_LOAD_FAIL = 'SITES_LOAD_FAIL'
export const SITE_CHANGE = 'SITE_CHANGE'
export const SITE_SAVE = 'SITE_SAVE'
export const SITE_SAVE_SUCCESS = 'SITE_SAVE_SUCCESS'
export const SITE_SAVE_FAIL = 'SITE_SAVE_FAIL'
export const SITE_DELETE = 'SITE_DELETE'
export const SITE_DELETE_SUCCESS = 'SITE_DELETE_SUCCESS'
export const SITE_DELETE_FAIL = 'SITE_DELETE_FAIL'
export const SITE_REGEN_KEYS = 'SITE_REGEN_KEYS'
export const SITE_REGEN_KEYS_SUCCESS = 'SITE_REGEN_KEYS_SUCCESS'
export const SITE_REGEN_KEYS_FAIL = 'SITE_REGEN_KEYS_FAIL'

export const TYPES_LOAD = 'TYPES_LOAD'
export const TYPES_LOAD_SUCCESS = 'TYPES_LOAD_SUCCESS'
export const TYPES_LOAD_FAIL = 'TYPES_LOAD_FAIL'
export const TYPE_SAVE = 'TYPE_SAVE'
export const TYPE_SAVE_SUCCESS = 'TYPE_SAVE_SUCCESS'
export const TYPE_SAVE_FAIL = 'TYPE_SAVE_FAIL'
export const TYPE_DELETE = 'TYPE_DELETE'
export const TYPE_DELETE_SUCCESS = 'TYPE_DELETE_SUCCESS'
export const TYPE_DELETE_FAIL = 'TYPE_DELETE_FAIL'

export const SETTINGS_LOAD = 'SETTINGS_LOAD'
export const SETTINGS_LOAD_SUCCESS = 'SETTINGS_LOAD_SUCCESS'
export const SETTINGS_LOAD_FAIL = 'SETTINGS_LOAD_FAIL'
export const SETTING_SAVE = 'SETTING_SAVE'
export const SETTING_SAVE_SUCCESS = 'SETTING_SAVE_SUCCESS'
export const SETTING_SAVE_FAIL = 'SETTING_SAVE_FAIL'
export const SETTING_DELETE = 'SETTING_DELETE'
export const SETTING_DELETE_SUCCESS = 'SETTING_DELETE_SUCCESS'
export const SETTING_DELETE_FAIL = 'SETTING_DELETE_FAIL'
export const ROLES_LOAD = 'ROLES_LOAD'
export const ROLES_LOAD_SUCCESS = 'ROLES_LOAD_SUCCESS'
export const ROLES_LOAD_FAIL = 'ROLES_LOAD_FAIL'
export const ROLE_SAVE = 'ROLE_SAVE'
export const ROLE_SAVE_SUCCESS = 'ROLE_SAVE_SUCCESS'
export const ROLE_SAVE_FAIL = 'ROLE_SAVE_FAIL'
export const ROLE_DELETE = 'ROLE_DELETE'
export const ROLE_DELETE_SUCCESS = 'ROLE_DELETE_SUCCESS'
export const ROLE_DELETE_FAIL = 'ROLE_DELETE_FAIL'

export const CONTENT_LOAD = 'CONTENT_LOAD'
export const CONTENT_LOAD_SUCCESS = 'CONTENT_LOAD_SUCCESS'
export const CONTENT_LOAD_FAIL = 'CONTENT_LOAD_FAIL'
export const CONTENT_SAVE = 'CONTENT_SAVE'
export const CONTENT_SAVE_SUCCESS = 'CONTENT_SAVE_SUCCESS'
export const CONTENT_SAVE_FAIL = 'CONTENT_SAVE_FAIL'
export const CONTENT_DELETE = 'CONTENT_DELETE'
export const CONTENT_DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS'
export const CONTENT_DELETE_FAIL = 'CONTENT_DELETE_FAIL'
export const CONTENT_REORDER = 'CONTENT_REORDER'
export const CONTENT_REORDER_SUCCESS = 'CONTENT_REORDER_SUCCESS'
export const CONTENT_REORDER_FAIL = 'CONTENT_REORDER_FAIL'

export const USERS_LOAD = 'USERS_LOAD'
export const USERS_LOAD_SUCCESS = 'USERS_LOAD_SUCCESS'
export const USERS_LOAD_FAIL = 'USERS_LOAD_FAIL'
export const USER_SAVE = 'USER_SAVE'
export const USER_SAVE_SUCCESS = 'USER_SAVE_SUCCESS'
export const USER_SAVE_FAIL = 'USER_SAVE_FAIL'
export const USER_DELETE = 'USER_DELETE'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAIL = 'USER_DELETE_FAIL'

export const SHEET_PUSH = 'SHEET_PUSH'
export const SHEET_POP = 'SHEET_POP'
export const SHEET_SET = 'SHEET_SET'
export const SHEET_CLEAR = 'SHEET_CLEAR'
export const ALERT_PUSH = 'ALERT_PUSH'

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'
export const SIGNUP = 'SIGNUP'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_FAIL = 'SIGNUP_FAIL'

export const ItemTypes = {
  TYPE: 'TYPE',
  SETTING: 'SETTING',
  CONTENT: 'CONTENT',
  PART_DEFINITION: 'PART_DEFINITION',
  PICKER: 'PICKER',
  FORM_LIST: 'FORM_LIST'
}



// WEBPACK FOOTER //
// ./app/constants.js